import { createServerFn } from '@tanstack/react-start'

import { requestPasswordResetInputSchema } from '@/features/Auth/ForgotPassword/validation.ts'
import { requestPasswordResetService } from '@/server/Auth/ForgotPassword/request.service.ts'

export const requestPasswordResetHandler = createServerFn({ method: 'POST' })
    .validator(function (data: unknown) {
        return requestPasswordResetInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        return requestPasswordResetService(data)
    })
